<template>
	<mobile v-if="mobile"></mobile>
	<pc v-else></pc>
</template>

<script>
	import pc from './insurance_list_pc.vue'
	import mobile from './insurance_list_m.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'insurance_list',
		
		components: {
			pc,
			mobile
		},
		
		computed: {
			...mapState(['mobile'])
		}
	};
</script>

<style lang="stylus" scoped>
</style>